import { render, staticRenderFns } from "./AmendmentCard.vue?vue&type=template&id=3f9f37ca"
import script from "./AmendmentCard.vue?vue&type=script&lang=js"
export * from "./AmendmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports